import { BaseModel } from './BaseModel';
import { Product } from './Product';

export class RationType extends BaseModel {
  hydrate(data, source) {
    const isApi = source === 'api';

    this.id = data.id;
    this.name = data.name;
    this.density = data.density;
    this.phase = data.phase;
    this.genericPhase = isApi ? data.generic_phase : data.genericPhase;
  }

  static fromApi(data) {
    return this.create(data, 'api');
  }

  static fromStore(data) {
    return this.create(data, 'store');
  }
}

export class Ration extends BaseModel {
  hydrate(data, source) {
    const isApi = source === 'api';

    this.typeId = isApi ? data.type_id : data.typeId ?? null;

    this.typeName = isApi ? data.type_name : data.typeName ?? null;

    this.phase = data.phase ?? null;
    this.density = data.density ?? null;

    this.availableWeight = isApi ? data.available_weight : data.availableWeight ?? null;

    this.product = data.product ? Product.create(data.product) : null;
  }

  static fromApi(data) {
    return this.create(data, 'api');
  }

  static fromStore(data) {
    return this.create(data, 'store');
  }
}

export class RationDelivery extends BaseModel {
  hydrate(data, source) {
    const isApi = source === 'api';

    this.id = data.id;
    this.date = data.date ? new Date(data.date) : null;
    this.age = data.age ?? null;
    this.quantity = data.quantity ?? null;
    this.measuredQuantity = isApi ? data.measured_quantity : data.measuredQuantity ?? null;
    this.measuredVolume = isApi ? data.measured_volume : data.measuredVolume ?? null;

    this.feedControl = FeedControlType.create(
      isApi ? data.feed_control_type : data.feedControlType,
      source
    );

    this.batchId = isApi ? data.batch : data.batchId ?? null;

    this.siloId = isApi ? data.silo.id : data.siloId ?? null;
    this.siloIdentification = isApi ? data.silo.identification : data.siloIdentification ?? null;

    const rationTypeData = isApi ? data.ration_type : data.rationType;
    this.rationType = rationTypeData ? RationType.create(rationTypeData, source) : null;
  }

  static fromApi(data) {
    return this.create(data, 'api');
  }

  static fromStore(data) {
    return this.create(data, 'store');
  }
}

export class FeedControlType extends BaseModel {
  hydrate(data, source) {
    const isApi = source === 'api';

    this.id = data.id;
    this.name = data.name;
    this.externalId = isApi ? data.external_id : data.externalId ?? null;
  }

  static fromApi(data) {
    return this.create(data, 'api');
  }

  static fromStore(data) {
    return this.create(data, 'store');
  }
}
